import * as Models from 'models';
import { isGroupLayoutDocument } from './isGroupLayoutDocument';
import { isReusableLayoutDocument } from './isReusableLayoutDocument';

export function isCombinedLayoutDocument(entity: Models.CombinedDocument): entity is Models.CombinedLayoutDocument;
export function isCombinedLayoutDocument(entity: Models.CombinedDocumentMap): entity is Models.CombinedLayoutDocumentMap;
export function isCombinedLayoutDocument(entity): boolean {
  return isReusableLayoutDocument(entity) || isGroupLayoutDocument(entity);
}
